export const productTypes = {
  CHARGE: 'charge',
  SUBSCRIPTION: 'subscription',
};

export const PRODUCT_TYPES = {
  SUBSCRIPTION: 'subscription',
  ONE_TIME: 'charge',
  PWYW: 'pwyw',
  LEAD_CAPTURE: 'lead_capture',
  PAYMENT_PLAN: 'payment_plan',
};
